import type { FlattenSimpleInterpolation } from 'styled-components'
import { css } from 'styled-components'

import { createMixin } from '@vfuk/core-mixins'

import type { Animation } from './animations.types'

const scaleUp: Animation = {
  animation: createMixin(
    (): FlattenSimpleInterpolation => css`
      @keyframes scaleUp {
        0% {
          transform: scale(0.9);
        }
        100% {
          transform: scale(1);
        }
      }
    `,
  ) as Animation['animation'],
  config: {
    duration: 150,
  },
}

export default scaleUp
